import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  newsData: [],
  totalnews: 0,
  isOpenModal: false,
  isImageOpenModal: false,
}

export const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    setnewsData(state, { payload }) {
      state.newsData = payload.result
      state.totalnews = payload.count
    },
    updatenewsData(state, { payload }) {
      const objIndex = state.newsData.findIndex((obj) => obj.id === payload.id);
      if (objIndex >= 0) {
        state.newsData[objIndex] = payload
      }
    },
    pushnewsData(state, { payload }) {
      state.newsData.push(payload)
    },
    sliceTestData(state, { payload }) {
      const objIndex = state.newsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.newsData.splice(objIndex, 1)
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    }
  }
})

export const { setnewsData, updatenewsData, pushnewsData, sliceTestData, isOpenModal, ModalToggle, isImageOpenModal, ImagestatusToggle } = newsSlice.actions;

export default newsSlice.reducer;

export function getnews(limit, offset, status, keyword) {
  return async function getnewsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getnews(limit, offset, status, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setnewsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addnews(payload) {
  return async function addnewsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addnews(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushnewsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatenews(id, data) {
  return async function updatenewsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatenews(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatenewsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateNewsImage(id, name) {
  return async function updateNewsImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateNewsImage(id, name).then(
        (response) => {
          dispatch(ImagestatusToggle())
          dispatch(setLoading(false))
          dispatch(updatenewsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deleteNewsImage(id) {
  return async function deleteNewsImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteNewsImage(id, 'deleted').then(
        (response) => {
          dispatch(sliceTestData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

